export default __webpack_public_path__ + "static/media/work_blog-main.0a871039.jpg";